import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectFeatureFlag } from '../features/featureFlags/selectors'
import { ESIGN_LSA_PAYMENT_UPFRONT } from '../config/featureFlagKeys'
import { getLsaChargeName, selectLsaChargeName, setLsaChargeName } from '../features/lsaChargeName/lsaChargeName'
import { CHARGE_NAME_NOT_REQUIRED } from '../constants/lsaChargeName'

const NO_OPTIONS = Object.freeze([])

const useLsaChargeName = (userId) => {
  const dispatch = useDispatch()
  const enabled = useSelector(selectFeatureFlag(ESIGN_LSA_PAYMENT_UPFRONT))
  const state = useSelector(selectLsaChargeName(userId))

  useEffect(() => {
    if (enabled && userId) dispatch(getLsaChargeName(userId))
  }, [enabled, userId, dispatch])

  const choose = useCallback((key) => dispatch(setLsaChargeName({ userId, key })), [dispatch, userId])

  if (!enabled) return CHARGE_NAME_NOT_REQUIRED

  const required = !!state?.required
  const pick = state?.pick || null

  return {
    required,
    options: state?.options || NO_OPTIONS,
    pick,
    ofRecord: state?.ofRecord || null,
    blocked: required && !pick,
    choose,
  }
}

export default useLsaChargeName
